"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import type { Locale } from "@/config/i18n";
import { CHAUFFEUR_SLUG_UI } from "./chauffeurSlugUi";
import { tr } from "@/config/localeText";

type CtaProps = {
  title: string;
  text: string;
  primaryHref: string;
  primaryLabel: string;
  locale?: Locale;
};

export const CtaSection = ({
  title,
  text,
  primaryHref,
  primaryLabel,
  locale = "fr",
}: CtaProps): JSX.Element => {
  const ui = tr(CHAUFFEUR_SLUG_UI, locale);
  return (
    <section className="border-y border-black/10 bg-white py-14 text-black">
      <div className="mx-auto max-w-[90rem] px-6 md:px-8">
        <motion.div
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.45 }}
          whileHover={{ y: -2 }}
          className="grid gap-5 rounded-3xl border border-black/15 bg-black/[0.03] p-6 md:grid-cols-[1fr_auto] md:items-end md:p-8"
        >
          <div>
            <p className="mb-2 text-xs uppercase tracking-[0.18em] text-gold-800">
              {ui.ctaEyebrow}
            </p>
            <h2 className="mb-2 font-space-age text-xl tracking-[0.2em]">
              {title}
            </h2>
            <p className="max-w-2xl text-sm text-black/80">{text}</p>
          </div>
          <Link
            href={primaryHref}
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-5 py-2 text-sm font-semibold text-black transition-colors hover:bg-gold-600 hover:text-white"
          >
            {primaryLabel}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CtaSection;
